module.exports = __webpack_public_path__ + "img/fighter.85d2a118.png";